import { useState } from 'react';
import { InfiniteData } from '@tanstack/react-query';
import { MDSDropdown } from '@marqvision/mds-v2';
import { useDomainFilterQuery } from '~/apis/websiteContent';
import { useLogger } from '~/hooks';
import { useTab } from '~/pages/WebsiteContent/_impersonation/@hooks/useTab';
import { useRequest } from '~/pages/WebsiteContent/_impersonation/List/@hooks/useRequest';
import { MonitoringFilterProtocolResponse } from '~/swagger/data-contracts';
import { mergePages, parseDropDown } from '~/utils';

export const DomainFilter = () => {
  const { request, onFilterChange } = useRequest();
  const { currentTabGroup } = useTab();
  const { amplitudeLogging } = useLogger();

  const [searchString, setSearchString] = useState('');
  const { data, isFetching, isFetchingNextPage, fetchNextPage } = useDomainFilterQuery(
    { ...request, limit: 30, search: searchString },
    {
      select: parseList,
    }
  );
  const { count, list } = mergePages(data?.pages);

  const handleChange = (value: number[]) => {
    onFilterChange('domain_id_filter', value);
    if (value.length > 0) {
      amplitudeLogging('applied filter', {
        Type: 'domain',
        Channel: 'website content',
        Page: currentTabGroup.replace(/-/g, ' '),
      });
    }
  };

  const handleFetchNextPage = () => {
    if (isFetching || isFetchingNextPage) return;
    fetchNextPage();
  };

  return (
    <MDSDropdown
      modules={[
        'hide-select-all',
        {
          type: 'search',
          onChange: setSearchString,
          debounce: 300,
        },
        {
          type: 'infinite',
          total: count,
          onScrollBottom: handleFetchNextPage,
          isLoading: isFetching || isFetchingNextPage,
        },
      ]}
      value={request.domain_id_filter ?? []}
      list={list}
      onChange={handleChange}
      label="Domain"
    />
  );
};

const parseList = (data: InfiniteData<MonitoringFilterProtocolResponse>) => {
  return {
    pageParams: data.pageParams,
    pages: data.pages.map((page) => parseDropDown(page)),
  };
};
